import './styles.scss';

export const TooltipContent = ({
  dateStr,
  items,
}: {
  dateStr: string;
  items: Array<{ color: string; name: string; value: number }>;
}) => {
  return (
    <div className="tv-tooltip">
      <div className="tv-tooltip-date">{dateStr}</div>
      <div className="tv-tooltip-items">
        {items.map((it, i) => (
          <div className="tv-tooltip-row" key={i}>
            <span className="tv-tooltip-dot" style={{ background: it.color }} />
            <span className="tv-tooltip-name">{it.name}</span>
            <span className="tv-tooltip-value">{(it.value * 100).toFixed(2)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};
